import { EmploymentStatus, EmploymentStatusResponse } from '@newday/plum-types';

export const getMockEmploymentStatus = (
  status = EmploymentStatus.other
): EmploymentStatusResponse => ({
  employmentStatus: status,
});
